module.exports = __webpack_public_path__ + "img/tab_bg.06ba5983.png";